module.exports = __webpack_public_path__ + "img/Support-skill-101.320a2cc0.png";